import { render, staticRenderFns } from "./strength.vue?vue&type=template&id=146e8a72&scoped=true&"
import script from "./strength.vue?vue&type=script&lang=js&"
export * from "./strength.vue?vue&type=script&lang=js&"
import style0 from "./strength.vue?vue&type=style&index=0&id=146e8a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e8a72",
  null
  
)

export default component.exports